import { defineRecipe } from '@chakra-ui/react';

import { spinnerDefaultColor, spinnerDefaultSize } from './spinner.kds';

/** KDS Spinner — SVG arc with spin animation; register as `spinner` in `theme/system.ts`. */
export const spinnerRecipe = defineRecipe({
  className: 'chakra-spinner',
  base: {
    display: 'inline-block',
    width: 'var(--spinner-size)',
    height: 'var(--spinner-size)',
    color: spinnerDefaultColor,
    animation: 'spin',
    animationDuration: 'slowest',
    flexShrink: 0,
    border: 'none',
    '& svg': {
      display: 'block',
      width: '100%',
      height: '100%',
    },
  },
  variants: {
    size: {
      inherit: { '--spinner-size': '1em' },
      xs: { '--spinner-size': 'sizes.3' },
      sm: { '--spinner-size': 'sizes.4' },
      md: { '--spinner-size': 'sizes.5' },
      lg: { '--spinner-size': 'sizes.8' },
      xl: { '--spinner-size': 'sizes.10' },
    },
  },
  defaultVariants: {
    size: spinnerDefaultSize,
  },
});
